import React, { useState, useEffect } from "react";
import axios from "axios";

const SellerSettings = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newAddress, setNewAddress] = useState({
    name: "",
    street: "",
    city: "",
    state: "",
    pincode: "",
    landmark: "",
  });

  const sellerId = localStorage.getItem("seller_id");

  // Fetch addresses on component mount
  useEffect(() => {
    if (sellerId) {
      fetchAddresses();
    }
  }, [sellerId]);

  // Fetch addresses by seller ID
  const fetchAddresses = async () => {
    try {
      setLoading(true);
      
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_seller_address",
        { seller_id: sellerId },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Fetch Response:", response.data);

      if (response.data.status === true && response.data.data) {
        // Handle both single object and array responses
        const addressData = Array.isArray(response.data.data) 
          ? response.data.data 
          : [response.data.data];
        setAddresses(addressData);
      }
    } catch (error) {
      console.error("Error fetching addresses:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddressChange = (e) => {
    setNewAddress({ ...newAddress, [e.target.name]: e.target.value });
  };

  const handleAddAddress = async (e) => {
    e.preventDefault();
    
    if (!newAddress.name || !newAddress.street) {
      alert("Please fill in required fields (Name and Street)");
      return;
    }

    if (!sellerId) {
      alert("Seller ID not found. Please login again.");
      return;
    }

    try {
      setLoading(true);
      
      const payload = {
        seller_id: sellerId,
        address: newAddress.name,
        street: newAddress.street,
        city: newAddress.city,
        state: newAddress.state,
        pincode: newAddress.pincode,
        landmark: newAddress.landmark,
        vacation_mode: "no"
      };

      console.log("Adding address payload:", payload);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_seller_address",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Add Response:", response.data);

      if (response.data.status === true) {
        alert("Address added successfully!");
        setNewAddress({ 
          name: "", 
          street: "", 
          city: "", 
          state: "", 
          pincode: "",
          landmark: "" 
        });
        fetchAddresses(); // Refresh the list
      } else {
        alert(response.data.message || "Failed to add address");
      }
    } catch (error) {
      console.error("Error adding address:", error);
      alert(error.response?.data?.message || "Failed to add address. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleToggleVacation = async (addressId, currentStatus) => {
    if (!sellerId) {
      alert("Seller ID not found. Please login again.");
      return;
    }

    try {
      setLoading(true);
      
      const payload = {
        id: addressId,
        seller_id: sellerId,
        vacation_mode: currentStatus === "yes" ? "no" : "yes"
      };

      console.log("Updating vacation mode:", payload);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_seller_address",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      console.log("Update Response:", response.data);

      if (response.data.status === true) {
        alert("Vacation mode updated successfully!");
        fetchAddresses(); // Refresh the list
      } else {
        alert(response.data.message || "Failed to update vacation mode");
      }
    } catch (error) {
      console.error("Error updating vacation mode:", error);
      alert(error.response?.data?.message || "Failed to update vacation mode. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Settings</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                <li className="breadcrumb-item active">Settings</li>
              </ol>
            </div>
          </div>
        </div>

        {/* My Address Section */}
        <div className="row">
          <div className="col-12">
            <div className="card p-2">
              <form onSubmit={handleAddAddress} className="row selladdform">
                <h5 className="fw-semibold mb-3">My Address</h5>
                <div className="col-md-4 mb-3">
                  <input 
                    type="text" 
                    className="form-control" 
                    name="name" 
                    placeholder="Full Name" 
                    value={newAddress.name} 
                    onChange={handleAddressChange} 
                    required 
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <input 
                    type="text" 
                    className="form-control" 
                    name="street" 
                    placeholder="Street Address" 
                    value={newAddress.street} 
                    onChange={handleAddressChange} 
                    required 
                  />
                </div>
                <div className="col-md-4 mb-3">
                  <input 
                    type="text" 
                    className="form-control" 
                    name="city" 
                    placeholder="City" 
                    value={newAddress.city} 
                    onChange={handleAddressChange} 
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <input 
                    type="text" 
                    className="form-control" 
                    name="state" 
                    placeholder="State" 
                    value={newAddress.state} 
                    onChange={handleAddressChange} 
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <input 
                    type="text" 
                    className="form-control" 
                    name="pincode" 
                    placeholder="Pincode" 
                    value={newAddress.pincode} 
                    onChange={handleAddressChange} 
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <input 
                    type="text" 
                    className="form-control" 
                    name="landmark" 
                    placeholder="Landmark" 
                    value={newAddress.landmark} 
                    onChange={handleAddressChange} 
                  />
                </div>
                <div className="col-md-3 mb-3 text-end">
                  <button 
                    className="btn btn-success" 
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? "Adding..." : "Add Address"}
                  </button>
                </div>
              </form>
            </div>

            {/* Existing Address List */}
            <div className="table-responsive card mt-3">
              {loading && addresses.length === 0 ? (
                <div className="text-center p-4">Loading addresses...</div>
              ) : (
                <table className="table table-bordered mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Street</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Pincode</th>
                      <th>Landmark</th>
                      <th>Vacation Mode</th>
                    </tr>
                  </thead>
                  <tbody>
                    {addresses.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No addresses found. Please add an address.
                        </td>
                      </tr>
                    ) : (
                      addresses.map((addr) => (
                        <tr key={addr.id}>
                          <td>{addr.address}</td>
                          <td>{addr.street}</td>
                          <td>{addr.city}</td>
                          <td>{addr.state}</td>
                          <td>{addr.pincode}</td>
                          <td>{addr.landmark || "-"}</td>
                          <td>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`vacationSwitch-${addr.id}`}
                                checked={addr.vacation_mode === "yes"}
                                onChange={() => handleToggleVacation(addr.id, addr.vacation_mode)}
                                disabled={loading}
                              />
                              <label 
                                className="form-check-label" 
                                htmlFor={`vacationSwitch-${addr.id}`}
                              >
                                {addr.vacation_mode === "yes" ? "ON" : "OFF"}
                              </label>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer mt-5 text-center">
          <div className="container-fluid">© 2025 Seller Portal</div>
        </footer>
      </div>
    </div>
  );
};

export default SellerSettings;